<template>
  <v-dialog v-model="dialog" persistent max-width="1000">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Adicionar</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <br /><br />
        <v-row>
          <v-col sm="3">
           <app-temas-combobox :filter="payload"> </app-temas-combobox>
          </v-col>
          <v-col sm="3">
            <v-text-field
              label="Texto"
              name="texto"
              type="text"
              v-model="payload.texto"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              label="Titulo"
              name="titulo"
              type="text"
              v-model="payload.titulo"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="3" class="file-names">
            <span class="name" v-if="imagemNomeBlob">{{imagemNomeBlob}}</span>
            <v-file-input
              accept="image/*"
              label="Imagem"
              prepend-icon="mdi-camera"
              v-model="payload.imagemBlob"
              @change="valueChange('imagemNomeBlob')"
            >
            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="3" class="file-names">
            <span class="name" v-if="imagemBronzeNomeBlob">{{imagemBronzeNomeBlob}}</span>
            <v-file-input
              accept="image/*"
              label="Imagem Bronze"
              v-model="payload.imagemBronzeBlob"
              prepend-icon="mdi-camera"
              @change="valueChange('imagemBronzeNomeBlob')"
            >
            </v-file-input>
          </v-col>
          <v-col sm="3" class="file-names">
            <span class="name" v-if="imagemPrataNomeBlob">{{imagemPrataNomeBlob}}</span>
            <v-file-input
              accept="image/*"
              label="Imagem Prata"
              v-model="payload.imagemPrataBlob"
              prepend-icon="mdi-camera"
              :rules="rules"
              @change="valueChange('imagemPrataNomeBlob')"
            >
            </v-file-input>
          </v-col>
          <v-col sm="3" class="file-names">
            <span class="name" v-if="imagemOuroNomeBlob">{{imagemOuroNomeBlob}}</span>
            <v-file-input
              accept="image/*"
              label="Imagem Ouro"
              v-model="payload.imagemOuroBlob"
              prepend-icon="mdi-camera"

              @change="valueChange('imagemOuroNomeBlob')"
            >

            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12">

          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { medalhaAPI } from '../API/Medalha'
import { mapActions } from 'vuex'
import AppTemasCombobox from './Combobox.vue'

export default {
  name: 'AppModalInsert',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  components: {
    AppTemasCombobox
  },
  data () {
    return {
      payload: {},
      dialog: false,
      imagemNomeBlob: this.object ? this.object.imagemNomeBlob : null,
      imagemBronzeNomeBlob: this.object ? this.object.imagemBronzeNomeBlob : null,
      imagemPrataNomeBlob: this.object ? this.object.imagemPrataNomeBlob : null,
      imagemOuroNomeBlob: this.object ? this.object.imagemOuroNomeBlob : null,
      rules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!'
      ]
    }
  },
  mounted () {
    if (this.object && this.edit === true) {
      this.payload = this.object
    }
  },
  methods: {
    ...mapActions(['setLoading']),
    valueChange (e) {
      this[e] = null
    },
    onConfirm () {
      let formData = new FormData()

      formData.append('texto', this.payload.texto)
      formData.append('imagemForm', this.payload.imagemBlob)
      formData.append('imagemPrataForm', this.payload.imagemPrataBlob)
      formData.append('imagemBronzeForm', this.payload.imagemBronzeBlob)
      formData.append('imagemOuroForm', this.payload.imagemOuroBlob)
      formData.append('regra', this.payload.regra)
      formData.append('temaId', this.payload.regra)
      formData.append('titulo', this.payload.titulo)

      if (this.edit === true) {
        formData.append('medalhaId', this.payload.medalhaId)
        medalhaAPI
          .update(formData)
          .then((resp) => {
            this.dialog = false
            location.reload()
          })
          .catch()
      } else {
        medalhaAPI
          .create(formData)
          .then((resp) => {
            this.dialog = false
            location.reload()
          })
          .catch()
      }
    }
  }
}
</script>
<style scoped>
.file-names {
  position: relative;
}

.name {
      position: absolute;
    bottom: 34px;
    left: 49px;
    /* color: #000; */
    width: 62%;
    color: rgba(0, 0, 0, 0.87);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
}
</style>
<style>
.v-file-input__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
